(() => {
  const classList = {
    toggleButton: 'js-accordion-trigger',
    content: 'js-accordion-panel',
  };

  const getContentByToggleButton = (button) => {
    const targetContentId = button.getAttribute('aria-controls');
    if (!targetContentId) {
      throw new Error('target content id is missing');
    }
    const targetContent = document.getElementById(targetContentId);
    if (!targetContent) {
      throw new Error('target content element is missing');
    }
    return targetContent;
  };

  const openContent = (button, content) => {
    button.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    content.style.maxHeight = `${content.children[0].clientHeight}px`;
    content.style.visibility = 'visible';
  };

  const closeContent = (button, content) => {
    button.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    content.style.maxHeight = '0';
    content.style.visibility = 'hidden';
  };

  const isContentOpen = (button, content) =>
    content.getAttribute('aria-hidden') === 'false' &&
    button.getAttribute('aria-expanded') === 'true';

  const toggleButtonEventInit = () => {
    const toggleButtons = document.getElementsByClassName(
      classList.toggleButton
    );
    for (const toggleButton of toggleButtons) {
      toggleButton.addEventListener('click', () => {
        const targetContent = getContentByToggleButton(toggleButton);
        if (isContentOpen(toggleButton, targetContent)) {
          closeContent(toggleButton, targetContent);
        } else {
          openContent(toggleButton, targetContent);
        }
      });
    }
  };
  window.addEventListener('DOMContentLoaded', toggleButtonEventInit);
})();
